import { Box, Img } from "@chakra-ui/react";
import { Link, Outlet } from "react-router-dom";
import sylvr_logo from "../../assets/images/sylvr-logo.jpg";
// import { ThemeProvider, useTheme } from "../../contexts/ThemeContext";
const NoLayout = () => {
  // const { isDarkMode, toggleDarkMode } = useTheme();
  return (
    <>
      <Box>
        <Box>
          <Link to={process.env.REACT_APP_SITE_URL}>
            <Img src={sylvr_logo} width={100} />
          </Link>
        </Box>
        {/* <button onClick={toggleDarkMode}>
          Switch to {isDarkMode ? "Light" : "Dark"} Mode
        </button> */}
        <Box p={"5px"}>
          <Outlet />
        </Box>
      </Box>
    </>
  );
};

export default NoLayout;
